<template>
  <div class="element-auth">
    <main>
      <div class="body">
        <template v-if="currentStep == 'login'">
          <ul>
            <li><h3 class="title">로그인</h3></li>

            <li><element-textbox v-model="formData.steps[0].name.value" :label="formData.steps[0].name.label" :error="formData.steps[0].name.error" :placeholder="formData.steps[0].name.placeholder"/></li>
            <li><element-textbox v-model="formData.steps[0].birthNumber.value" :label="formData.steps[0].birthNumber.label" :error="formData.steps[0].birthNumber.error" :placeholder="formData.steps[0].birthNumber.placeholder"/></li>
            <li><element-certification @certification="certification" v-model="formData.steps[0].phone.value" :label="formData.steps[0].phone.label" :error="formData.steps[0].phone.error" :placeholder="formData.steps[0].phone.placeholder"/></li>
            <li v-if="statusCertification"><element-textbox v-model="formData.steps[0].certification.value" :label="formData.steps[0].certification.label" :error="formData.steps[0].certification.error" :placeholder="formData.steps[0].certification.placeholder" /></li>
          </ul>
        </template>

        <template v-if="currentStep == 'signup'">
          <ul>
            <li><h3 class="title">회원가입</h3></li>
            <!-- 이름 -->
            <li><element-textbox v-model="formData.steps[1].name.value" :label="formData.steps[1].name.label" :error="formData.steps[1].name.error" :placeholder="formData.steps[1].name.placeholder"/></li>
            <li>  
              <template v-if="isCarInsure">
                <!-- 주민 번호 || 법인 번호 -->
                <template v-if=" $props.data.formData.usage.value !== '법인' ">
                  <!-- <element-textbox-splited inputType="birthday" v-model="formData.steps[1].birthNumber.value" :label="formData.steps[1].name.label" :error="formData.steps[1].birthNumber.error" :placeholder="formData.steps[1].birthNumber.placeholder" :isCarInsure="isCarInsure"/> -->
                  <element-textbox class="split" v-model="formData.steps[1].birthNumber.value" :label="formData.steps[1].identNumber.label"   :error="formData.steps[1].birthNumber.error"  :placeholder="formData.steps[1].birthNumber.placeholder"/>
                  <element-textbox class="split" v-model="formData.steps[1].identNumber.value" :label="formData.steps[1].identNumber.label"   :error="formData.steps[1].identNumber.error"  :placeholder="formData.steps[1].identNumber.placeholder"/>
                </template>
                <tempalte v-else> <!-- 법인 -->
                  <element-textbox 
                  v-model="formData.steps[1].businessRegistrationNumber.value"  
                  :label="formData.steps[1].businessRegistrationNumber.label" 
                  :error="formData.steps[1].businessRegistrationNumber.error" 
                  :placeholder="formData.steps[1].businessRegistrationNumber.placeholder"/>
                </tempalte>
              </template>
              
              <template v-else>
                <element-textbox v-model="formData.steps[1].birthNumber.value" :label="formData.steps[1].birthNumber.label" :error="formData.steps[1].birthNumber.error" :placeholder="formData.steps[1].birthNumber.placeholder"/>
              </template>

              
            </li>

            <li><!-- 이메일 -->
              <element-textbox v-model="formData.steps[1].email.value" :label="formData.steps[1].email.label" :error="formData.steps[1].email.error" :placeholder="formData.steps[1].email.placeholder"/>
            </li>
            <!-- 인증 -->
            <li><element-certification @certification="certification" v-model="formData.steps[1].phone.value" :label="formData.steps[1].phone.label" :error="formData.steps[1].phone.error" :placeholder="formData.steps[1].phone.placeholder"/></li>
            <li v-if="statusCertification"><element-textbox v-model="formData.steps[1].certification.value" :label="formData.steps[1].certification.label" :error="formData.steps[1].certification.error" :placeholder="formData.steps[1].certification.placeholder" /></li>
          </ul>
        </template>

        <template v-if="currentStep == 'info'" >
          <ul>
            <li><h3 class="title">가입자</h3></li>

            <li><element-textbox v-model="formData.steps[2].name.value" :label="formData.steps[2].name.label" :error="formData.steps[2].name.error" :placeholder="formData.steps[2].name.placeholder" :disabled="'disabled'"/></li>
            <li><element-textbox v-model="formData.steps[2].birthNumber.value" :label="formData.steps[2].birthNumber.label" :error="formData.steps[2].birthNumber.error" :placeholder="formData.steps[2].birthNumber.placeholder" /></li>
            <li><element-textbox v-model="formData.steps[2].phone.value" :label="formData.steps[2].phone.label" :error="formData.steps[2].phone.error" :placeholder="formData.steps[2].phone.placeholder" /></li>
            <li><div class="caution">연락받으실 휴대폰 번호이며, 수정이 가능합니다.</div></li>
            <li><element-textbox v-model="formData.steps[2].email.value" :label="formData.steps[2].email.label" :error="formData.steps[2].email.error" :placeholder="formData.steps[2].email.placeholder" /></li>
            <li><div class="caution">(선택) 보험료 비교견적서를 받으실 주소입니다.</div></li>
          </ul>

        </template>
      </div>
    </main>
    <footer>
      <div class="terms">
        <template v-if="currentStep == 'login'">
          <element-checkbox-have-detail v-model="formData.steps[0].terms.value" :label="formData.steps[0].terms.label" :error="formData.steps[0].terms.error" />
        </template>
        <template v-if="currentStep == 'signup'">
          <element-checkbox-have-detail v-model="formData.steps[1].terms.value" :label="formData.steps[1].terms.label" :error="formData.steps[1].terms.error" />
        </template>
      </div>

      <div class="buttons">
        <template v-if="currentStep == 'login'">
          <button id="on" :class="{disabled: !formData.steps[0].terms.value[0].value}" @click="validate(1, 'info')">로그인</button>
          아직 인슈넷FC 회원이 아니십니까?<br/>
          입력한 정보를 바탕으로 간편하게 회원가입하세요.
          <button @click="currentStep = 'signup'">회원가입</button>
        </template>

        <template v-if="currentStep == 'signup'">
          <button id="on" @click="validate(2, 'info')">회원가입</button>
          <button @click="currentStep = 'login'">로그인으로 돌아가기</button>
        </template>
      </div>
    </footer>
  </div>
</template>
<script>

export default {
  props: [ "data", "isCarInsure" ],
  data(){
    return {
      availableNext: false,
      currentStep: 'login',
      statusCertification: false,
      certificationCode: "",
      formData: {
        steps: [
          {
            title: "로그인",
            value: "",
            name: {
              label: "이름",
              error: "",
              value: "",
              placeholder: "이름",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            birthNumber: {
              label: "생년월일",
              error: "",
              value: "",
              placeholder: "앞 6자리 입력",
              validations: [
                { type: "birth", message: "필수항목입니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            phone: {
              label: "휴대폰 번호",
              error: "",
              value: "",
              placeholder: "- 없이 입력",
              validations: [
                { type: "certification", message: "인증번호를 입력하셔야합니다" },
                { type: "required", message: "필수항목입니다" },
                { type: "number", message: "숫자만 입력 가능합니다" },
              ]
            },
            terms: {
              label: "약관",
              error: "",
              value: [
                { label: "개인정보 수집 및 회원 약관 동의(필수)", value: false },
                /*{ label: "인슈넷FC 회원 약관 동의(필수)", value: false }*/
              ],
              validations: [
                { type: "terms-required", message: "필수항목입니다" },
              ]
            },
            certification: {
              label: "인증번호",
              value: "",
              error: "",
              validations: [
                { type: "check", message: "인증번호가 일치하지 않습니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            haslogin: {
              label: "회원번호",
              value: "",
              validations: [
                { type: "required", message: "-" }
              ]
            },
          },
          {
            title: "회원가입",
            name: {
              label: "이름",
              error: "",
              value: "",
              placeholder: "이름",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            phone: {
              label: "휴대폰 번호",
              error: "",
              value: "",
              placeholder: "- 없이 입력",
              validations: [
                { type: "certification", message: "인증번호를 입력하셔야합니다" },
                { type: "required", message: "필수항목입니다" }

              ]
            },
            email: {
              label: "이메일",
              error: "",
              value: "",
              placeholder: "이메일 주소 입력",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            birthNumber: {
              label: "생년월일",
              error: "",
              value: "",
              placeholder: "앞 6자리 입력",
              validations: [
                { type: "birth", message: "필수항목입니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            identNumber: {
              label: "주민번호",
              error: "",
              value: "",
              placeholder: "뒷 7자리 입력",
              validations: [
                { type: "birth-ident", message: "필수항목입니다" },
                { type: "required", message: "필수항목입니다" }
              ],
              use: false
            },
            businessRegistrationNumber: {
              label: "사업자번호",
              error: "",
              value: "",
              placeholder: "사업자등록번호 10자리 입력",
              validations: [
                { type: "business", message: "필수항목입니다" },
                { type: "required", message: "필수항목입니다" }
              ],
            },

            terms: {
              label: "약관",
              error: "",
              value: [
                { label: "개인정보 수집 및 회원 약관 동의(필수)", value: false },
                /*{ label: "인슈넷FC 회원 약관 동의(필수)", value: false }*/
              ],
              validations: [
                { type: "terms-required", message: "필수항목입니다" },
              ]
            },
            certification: {
              label: "인증번호",
              value: "",
              error: "",
              validations: [
                { type: "check", message: "인증번호가 일치하지 않습니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            haslogin: {
              label: "회원번호",
              value: "",
              validations: [
                { type: "required", message: "-" }
              ]
            },
          },
          {
            title: "가입자",
            name: {
              label: "이름",
              error: "",
              value: "",
              placeholder: "이름"
            },
            birthNumber: {
              label: "생년월일",
              error: "",
              value: "",
              placeholder: "앞 6자리 입력",
              validations: [
                { type: "birth", message: "필수항목입니다" },
                { type: "required", message: "필수항목입니다" }
              ]
            },
            phone: {
              label: "휴대폰 번호",
              error: "",
              value: "",
              placeholder: "- 없이 입력",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            email: {
              label: "이메일",
              error: "",
              value: "",
              placeholder: "이메일 주소 입력",
              validations: [
                { type: "required", message: "필수항목입니다" }
              ]
            },
            haslogin: {
              label: "회원번호",
              value: "",
              validations: [
                { type: "required", message: "" }
              ]
            },
          }
        ]
      }
    }
  },
  mounted() {
    this.$watch( "currentStep", ( newData, oldData ) => {
      if(newData == "login") {
        this.$parent.proxy_data = this.formData.steps[0]
      }else if(newData == "signup"){
        this.$parent.proxy_data = this.formData.steps[1]
      }else if(newData == "info"){
        this.$emit("updateprocessorData", {
          haslogin: this.$store.state.customer.profile._id,
          phone: this.formData.steps[2].phone.value,
          name: this.formData.steps[2].name.value,
          email: this.formData.steps[2].email.value
        })
        this.$parent.proxy_data = this.formData.steps[2]
      }
    });
    this.$watch( "formData.steps", ( newData, oldData ) => {
      if( newData ){
        if(this.currentStep == "login"){
          this.$parent.proxy_data = this.formData.steps[0]
          this.$parent.$parent.validate(false, this.formData.steps[0])
          Object.values( this.formData.steps[0] ).forEach( o => {
            if(!this.checkValidation( o, false )) {}
          });
        }else if(this.currentStep == "signup"){
          this.$parent.proxy_data = this.formData.steps[1]
          this.$parent.$parent.validate(false, this.formData.steps[1])
          Object.values( this.formData.steps[1] ).forEach( o => {
            if(!this.checkValidation( o, false ))  {}
          });
        }else if(this.currentStep == "info"){
          var t = true;
          this.$parent.proxy_data = this.formData.steps[2]
          this.$parent.$parent.validate(false, this.formData.steps[2])
          Object.values( this.formData.steps[2] ).forEach( o => {
            if(!this.checkValidation( o, false )) {
              t = false;
            }
          });
          if(t) {
            this.$emit("updateprocessorData", {
              haslogin: this.$store.state.customer.profile._id,
              phone: this.formData.steps[2].phone.value,
              name: this.formData.steps[2].name.value,
              email: this.formData.steps[2].email.value
            })
          }
        }

      };
    }, { immediate: true, deep: true });

    if(this.isCarInsure){
      this.currentStep = 'login'
      this.formData.steps[1].identNumber.use = true
    }else{
      this.formData.steps[1].identNumber.use = false
    }
    this.setUserData();
  },
  created(){
    if(this.currentStep == "login"){
      this.$parent.proxy_data = this.formData.steps[0]
    }else if(this.currentStep == "signup"){
      this.$parent.proxy_data = this.formData.steps[1]
    }else if(this.currentStep == "info"){
      this.setUserData();
      this.$parent.proxy_data = this.formData.steps[2]
    }
  },
  methods: {
    setUserData: function(fromNew) {
      let token = localStorage.eleToken;

      let profile = JSON.parse(localStorage.getItem( "profile" ));

      if(token && profile._id){
        let extra = JSON.parse(profile.customer_extra)
        this.formData.steps[2].name.value = profile.customer_name;
        this.formData.steps[2].email.value = profile.customer_email;
        this.formData.steps[2].birthNumber.value = profile.customer_social_number ? profile.customer_social_number.substr(0,6) : ''; 
        this.formData.steps[2].phone.value = profile.customer_phone_number ? profile.customer_phone_number : extra.phone[0].number;
        this.formData.steps[0].haslogin.value = profile._id;
        if(fromNew) {
          //force update
          this.$emit("updateprocessorData", {
            haslogin: this.$store.state.customer.profile._id,
            phone: this.formData.steps[2].phone.value,
            birth: this.formData.steps[2].birthNumber.value,
            name: this.formData.steps[2].name.value,
            email: this.formData.steps[2].email.value,
          })
          this.$parent.proxy_data = this.formData.steps[2]
          this.$parent.$parent.nextStep();
        }
        this.currentStep = 'info';
        
        //this.$emit( "input", profile._id );
      }else{
        if(this.data && this.data.formData) {
          this.formData.steps[0].name.value = this.data.formData.name ? this.data.formData.name.value : '';
          this.formData.steps[1].name.value = this.data.formData.name ? this.data.formData.name.value : '';

          this.formData.steps[0].birthNumber.value = this.data.formData.birth ? this.data.formData.birth.value : '';
          this.formData.steps[1].birthNumber.value = this.data.formData.birth ? this.data.formData.birth.value : '';
          this.formData.steps[2].birthNumber.value = this.data.formData.birth ? this.data.formData.birth.value : '';
        }
      }
    },
    certification: function( value ) {
      this.statusCertification = value.check;
      this.certificationCode = Math.floor(Math.random()*(999999-100000+1)) + 100000;
      this.$store.dispatch( "customer/getCertification", { data: value.value, code: this.certificationCode } ).then(res => {
      });
    },
    validate( current, value ) {
      if(current == 1){
        if(this.validateField(current-1)){
          this.$store.dispatch( "customer/getAuth", { phone: this.formData.steps[0].phone.value, name: this.formData.steps[0].name.value } ).then(res => {
            if(res.data.status !== 'error'){
              this.$store.dispatch( "customer/refresh" ).then( res => {
                this.setUserData();
                this.currentStep = value;
              });
            }
            else{
              this.$store.commit( "elementSnackbar/SET_ITEM", { message: "이름 또는 핸드폰 번호가 올바르지 않습니다.", status: "false" } );
              // 일치 하는 회원 없는 경우 바로 회원가입
            }
          });

        }
      }
      else{
        // 법인 고객이면 사업자번호를 생년월일 변수에 넣는다
        if (this.formData.steps[1].businessRegistrationNumber.value) {
          this.formData.steps[1].identNumber.validations[1].type = "";
          this.formData.steps[1].birthNumber.validations[0].type = "business";
          this.formData.steps[1].birthNumber.value = this.formData.steps[1].businessRegistrationNumber.value;

        } else {
          this.formData.steps[1].businessRegistrationNumber.validations[1].type = "";
          
        }

        if(this.validateField(current - 1)){
          this.$store.dispatch( "customer/regist", {
              customer_name: this.formData.steps[1].name.value,
              customer_social_number: this.formData.steps[1].birthNumber.value + this.formData.steps[1].identNumber.value,
              customer_email: this.formData.steps[1].email.value,
              phone: this.formData.steps[1].phone.value
            } ).then(res => {
            if(res.data.status !== 'error'){
              // 회원정보를 crm_customer 에 등록 후 customer_id 와 phone 정보를 crm_customer_phone에 저장
              this.$store.dispatch( "customer/registPhone", {phone: this.formData.steps[1].phone.value, customerid: res.data.data._id } ).then(res => {
                if(res.data.status !== 'error'){
                  this.$store.dispatch( "customer/refresh" ).then( res => {
                    this.setUserData(true);
                    /* 가입완료시 가입자 페이지 건너뜀 2020-05*/
                    console.log("REG OK")
                    
                  });
                }
                else{
                  this.$store.commit( "elementSnackbar/SET_ITEM", { message: "ERROR OCCURED", status: "false" } );
                }
              });

            }else{

              if (res.data.error =="2102:ALREADY_REGISTERED_USER") {
                  // this.$store.commit( "elementSnackbar/SET_ITEM", { message: "이미 가입된 회원입니다.", status: "false" } );
                  if(confirm("이미 가입된 회원입니다.\n입력하신 정보로 로그인을 하시겠습니까?")){
                    if(this.validateField(current-1)){
                      this.$store.dispatch( "customer/getAuth", { phone: this.formData.steps[1].phone.value, name: this.formData.steps[1].name.value } ).then(res => {
                        if(res.data.status !== 'error'){
                          this.$store.dispatch( "customer/refresh" ).then( res => {
                            this.setUserData();
                            this.currentStep = value;
                          });
                        }
                        else{
                          this.$store.commit( "elementSnackbar/SET_ITEM", { message: "이름 또는 핸드폰 번호가 올바르지 않습니다.", status: "false" } );
                        }
                      });

                    }
                  }
              }else {
                  this.$store.commit( "elementSnackbar/SET_ITEM", { message: "에러가 발생했습니다. 관리자에게 문의하십시오.", status: "false" } );
              }

            }
          });

        }
      }
    },
    isEmpty(value) {
      return ( value === undefined
        || value === null
        || (typeof value === 'object' && Object.keys(value).length === 0)
        || (typeof value === 'string' && value.trim().length === 0)
      )
    },
    validateField( index, setError = true ){
      var result = true;
      Object.values( this.formData.steps[index] ).forEach( o => {
        if( !this.checkValidation( o, setError ) && o.label != "회원번호" ) {
          result = false;
        }
      });

      return result;
    },
    checkValidation( ob, setError ){
      if( !ob.validations || (ob.use === false) ) return true;
      var result = null;
      var vm = this;
      ob.validations.forEach( o => {
        if( o.type.split( ":" ).length > 1 ){
          var vn = o.type.split( ":" )[0];
          var vv = o.type.split( ":" )[1];
          switch( vn ){
            case "min" :
              if( ob.value.length < vv ){
                result = o.message;
              };
            break;
            case "max" :
              if( ob.value.length > vv ){
                result = o.message;
              };
            break;
            case "matchField" :
              if( ob.value != this.formData[vv].value ){
                result = o.message;
              };
            break;
            case "matchString" :
              if( ob.value != vv ){
                result = o.message;
              };
            break;
          };
        }else{
          var vn = o.type;
          switch( vn ){
            case "email" :
              var regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
              if( !regExp.test( ob.value ) ){
                result = o.message;
              };
            break;
            case "required" :
              if( typeof ob.value != "number" && !ob.value ){
                result = o.message;
              };
            break;
            case "number" :
              var regExp = /^[0-9]*$/;
              if( !regExp.test( ob.value ) ){
                result = o.message;
              };
            break;
            case "birth" :
              //6자리만 입력되도로 정규화
              if (ob.value.length>6 ) {
                ob.value = ob.value.substr(0,6)
              }
              //숫자 입력되로고 정규화 추가
              var regNumber = /^[0-9]*$/;
              if (!regNumber.test(ob.value)) {
                ob.value = "";
              }
              var regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
              if( !regExp.test( ob.value ) ){
                result = o.message;
              }
            break;

            case "business" :
                  //10자리만 입력되도록 정규화
                  if (ob.value.length>10 ) {
                    ob.value = ob.value.substr(0,10)
                  }
                  //숫자만 입력되도록 정규화 추가
                  var regNumber = /^[0-9]*$/;
                  if (!regNumber.test(ob.value)) {
                    ob.value = "";
                  }
                  var regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
                  if( !regExp.test( ob.value ) ){
                    result = ob.message;
                  };  
            break;

            case "birth-ident" :
              //7자리만 입력되도로 정규화
              if (ob.value.length>7 ) {
                ob.value = ob.value.substr(0,7)
              }
              //숫자 입력되로고 정규화 추가
              var regNumber = /^[0-9]*$/;
              if (!regNumber.test(ob.value)) {
                ob.value = "";
                result = o.message;
              }
              break;
            case "certification" :
              if(!vm.statusCertification && ((vm.currentStep === 'login' && !vm.formData.steps[0].certification.value ) || (vm.currentStep === 'signup' && !vm.formData.steps[1].certification.value ))) {
                result = o.message;
              }
            break;
            case "birth-required" :
              if( typeof ob.value[0].value != "number" && !ob.value[0].value && typeof ob.value[1].value != "number" && !ob.value[1].value ){
                result = o.message;
              }
              break;
            case "terms-required" :
              if( !ob.value[0].value ){ //|| !ob.value[1].value
                result = o.message;
              }
            break;
            case "check" :
              if( ob.value != vm.certificationCode ){
                result = o.message;
              }
            break;
          };
        }
      });
      if( result ){
        if( setError ) ob.error = result;
        return false;
      }else{
        if( setError ) ob.error = null;
        return true;
      };
    }
  }
}
</script>
<style lang="scss" scoped>
  .element-auth button.disabled{
    border-color: #787878 !important;
    background-color: #787878 !important;
  }
</style>
